import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

//image xanh
import ImgKichHoat from '../../assets/image/action/h-kich-hoat-1.png';
import ImgHuongDan from '../../assets/image/action/h-huong-dan-1.png';
import ImgTraCuu from '../../assets/image/action/h-tra-cuu-1.png';
import ImgTram from '../../assets/image/action/h-tram-1.png';
import Asset20 from '../../assets/image/logo_gigacare/Asset20.png';
import Tineco from '../../assets/image/logo/Artboard1.png';
import Ecovacs from '../../assets/image/logo/Artboard2.png';
import Lumias from '../../assets/image/logo/Artboard4.png';
import kingsmith from '../../assets/image/logo/Artboard5.png';
import gigabotHello from '../../assets/image/mascot/gigabot-hello.png';
import gigabot20 from '../../assets/image/mascot/GIGABOT-20.png';
import gigabotSearch from '../../assets/image/mascot/GIGABOT-9.png';
import gigabotTaoPhieu from '../../assets/image/mascot/gigabot-taophieu.png';
import gigabot21 from '../../assets/image/mascot/GIGABOT-21.png';
import gigabot12 from '../../assets/image/mascot/GIGABOT-12.png';
import IconSupport1 from '../../assets/image/action/supportIcon/1.png';
import IconSupport2 from '../../assets/image/action/supportIcon/2.png';
import IconSupport3 from '../../assets/image/action/supportIcon/3.png';
import IconSupport4 from '../../assets/image/action/supportIcon/4.png';
import Gigacare1 from '../../assets/image/action/supportIcon/gigacare1.jpg';
import Gigacare2 from '../../assets/image/action/supportIcon/gigacare2.jpg';
import Gigacare3 from '../../assets/image/action/supportIcon/gigacare3.jpg';

import artboard from '../../assets/image/action/icon-gigabot/Artboard.png';
import artboard1 from '../../assets/image/action/icon-gigabot/Artboard1.png';
import artboard2 from '../../assets/image/action/icon-gigabot/Artboard2.png';
import artboard3 from '../../assets/image/action/icon-gigabot/Artboard3.png';
import artboard4 from '../../assets/image/action/icon-gigabot/Artboard4.png';
import artboard5 from '../../assets/image/action/icon-gigabot/Artboard5.png';
import artboard6 from '../../assets/image/action/icon-gigabot/Artboard6.png';
import artboard7 from '../../assets/image/action/icon-gigabot/Artboard7.png';
import banner1 from '../../assets/image/action/icon-gigabot/banner1.png';
import banner2 from '../../assets/image/action/icon-gigabot/banner2.png';
import AnhBia1 from '../../assets/image/mascot/AnhBia1.jpg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ZaloIcon from '../../assets/image/icon/zalo-icon.png';
import { faPhone, faCommentDots, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';

import logoZalo from '../../assets/image/logo/iconZalo.png';
import logoFace from '../../assets/image/logo/logoFace.png';

// import ImgYeuCau from '../../assets/image/action/h-yeu-cau-1.png'
// import ImgTaoPhieu from '../../assets/image/action/contact-form.png'
// import ImgKhuyenCao from '../../assets/image/action/contract.png'
// import ImgTaoPhieuWhite from "../../assets/image/action/contact-formwhite.png";
// import ImgKhuyenCaoWhite from "../../assets/image/action/contractwhite.png";
// import ImgKichHoatWhite from "../../assets/image/action/h-kich-hoat-at.png";
// import ImgHuongDanWhite from "../../assets/image/action/h-huong-dan-at.png";
// import ImgTraCuuWhite from "../../assets/image/action/h-tra-cuu-at.png";
// import ImgYeuCauWhite from "../../assets/image/action/h-yeu-cau-at.png";
//image trắng

const CheckBaoHanh = () => {
  const [open, setOpen] = useState(true);

  return (
    <>
      <div className="giga-electric" style={{ position: 'relative' }}>
        <div className="info bg-white">
          <div className="container-md d-none d-lg-block">
            <div className="d-flex justify-content-center">
              <img className="banner-phu" src={banner1} alt="" />
              <img src={AnhBia1} className="w-100" alt="" />
              <img className="banner-phu" src={banner2} alt="" />
            </div>
          </div>
          <div className="d-lg-none d-block">
            <div className="d-flex justify-content-center">
              <img className="banner-phu" src={banner1} alt="" />
              <img src={AnhBia1} className="w-100" alt="" />
              <img className="banner-phu" src={banner2} alt="" />
            </div>
          </div>
          {/* <div className='text-center mt-4'>
          <img className='item-logo-gigacare' src={Asset20} alt='' />
        </div> */}
          <div className="mt-lg-5 container mt-3" style={{ width: '65%' }}>
            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeOutDown" duration={1.5} delay={0} animateOnce={true} initiallyVisible={false}>
              <p className="text-title-banner text-primary text-center">CHÀO MỪNG BẠN ĐẾN VỚI GIGA care</p>

              <p className="mt-lg-4 text-title-banner text-primary mt-3 text-center">TRUNG TÂM BẢO HÀNH ỦY QUYỀN CHÍNH HÃNG CỦA CÁC THƯƠNG HIỆU</p>
            </ScrollAnimation>
            {/* <ScrollAnimation
            animateIn="fadeInUp"
            animateOut="fadeOutDown"
            duration={1.5}
            delay={0}
            animateOnce={true}
            initiallyVisible={false}
          >
            
                
          </ScrollAnimation> */}
            <div className="row g-4 my-xl-4 my-2">
              <div className="col-6 col-xxl-3">
                <img className="item-logo-hang" src={Lumias} alt="" />
              </div>
              <div className="col-6 col-xxl-3">
                <img className="item-logo-hang" src={Ecovacs} alt="" />
              </div>
              <div className="col-6 col-xxl-3">
                <img className="item-logo-hang" src={Tineco} alt="" />
              </div>
              <div className="col-6 col-xxl-3">
                <img className="item-logo-hang" src={kingsmith} alt="" />
              </div>
            </div>
          </div>

          {/* <ScrollAnimation
          animateIn="jackInTheBox"
          animateOut="fadeOutDown"
          duration={1.5}
          delay={0}
          animateOnce={true}
          
        > */}

          {/* </ScrollAnimation> */}

          <div className="container" style={{ width: '65%', marginBottom: '40px' }}>
            <hr />
          </div>

          <div style={{ backgroundColor: '#fff', marginTop: '50px' }}>
            <div className="let-me-help p-lg-4 container p-2" style={{ width: '65%' }}>
              <div className="list-items-button mb-1" style={{ paddingBottom: '30px', display: 'block' }}>
                <h2
                  className="w-100 text-capitalize text-primary text-for-help mt-3 text-center"
                  style={{
                    fontWeight: 600,
                    letterSpacing: '2px',
                    fontSize: '35px',
                  }}
                >
                  <b style={{ color: '#2e75b6 !important' }}>HÃY ĐỂ CHÚNG TÔI HỖ TRỢ BẠN</b>
                </h2>
                <div className="row">
                  <div className="col-lg-3 col-6 d-flex justify-content-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={0}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/kich-hoat-bao-hanh" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard6} alt="" />
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Kích hoạt</p>
                          <p className="cta-text">bảo hành</p>
                        </div>
                      </a>
                    </ScrollAnimation>
                  </div>
                  <div className="col-lg-3 col-6 d-flex justify-content-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={50}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/thoi-han-bao-hanh" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard7} alt="" />
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Kiểm tra</p>
                          <p className="cta-text">thời gian</p>
                          <p className="cta-text">bảo hành</p>
                        </div>
                      </a>
                    </ScrollAnimation>
                  </div>
                  <div className="col-lg-3 col-6 d-flex justify-content-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={100}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/chinh-sach-bao-hanh" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard1} alt="" />
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Chính sách</p>
                          <p className="cta-text">bảo hành</p>
                        </div>
                      </a>
                    </ScrollAnimation>
                  </div>
                  <div className="col-lg-3 col-6 d-flex justify-content-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={150}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/khuyen-cao-su-dung" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard5} alt="" />
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Khuyến cáo</p>
                          <p className="cta-text">robot hút bụi</p>
                        </div>
                        {/* <p className="cta-text">KHUYẾN CÁO CHO ROBOT HÚT BỤI</p> */}
                      </a>
                    </ScrollAnimation>
                  </div>
                  <div className="col-lg-3 col-6 d-flex justify-content-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={200}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/gui-yeu-cau" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard} alt="" />
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Tạo yêu cầu</p>
                          <p className="cta-text">bảo hành</p>
                        </div>
                      </a>
                    </ScrollAnimation>
                  </div>
                  <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={250}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/tra-cuu-bao-hanh" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard4} alt="" />
                        {/* <p className="cta-text">TRA CỨU TIẾN ĐỘ BẢO HÀNH</p> */}
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Tra cứu</p>
                          <p className="cta-text">tiến độ</p>
                          <p className="cta-text">bảo hành</p>
                        </div>
                      </a>
                    </ScrollAnimation>
                  </div>
                  <div className="col-lg-3 col-6 d-flex justify-content-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={300}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/phu-kien" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard3} alt="" />
                        {/* <p className="cta-text">PHỤ KIỆN THAY THẾ CHÍNH HÃNG</p> */}
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Phụ kiện</p>
                          <p className="cta-text">chính hãng</p>
                        </div>
                      </a>
                    </ScrollAnimation>
                  </div>
                  <div className="col-lg-3 col-6 col-sm-6 d-flex justify-content-center">
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeOutDown"
                      duration={1.5}
                      delay={350}
                      animateOnce={true}
                      initiallyVisible={false}
                      className="text-bao-hanh-sub d-flex justify-content-center align-items-center my-4"
                      style={{ width: '85%' }}
                    >
                      <a href="/tram-bao-hanh/ha-noi" className="d-flex justify-content-center align-items-center zoom-on-hover my-4">
                        <img className="item-icon-baohanh" src={artboard2} alt="" />
                        {/* <p className="cta-text">TÌM KIẾM TRUNG TÂM BẢO HÀNH</p> */}
                        <div className="ms-lg-2 p-lg-0 ms-1 p-1">
                          <p className="cta-text">Tìm kiếm</p>
                          <p className="cta-text">trung tâm</p>
                          <p className="cta-text">bảo hành</p>
                        </div>
                      </a>
                    </ScrollAnimation>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="giai-dap mt-lg-5 container mt-4 bg-white" style={{ width: '65%' }}>
            <h2 className="fw-bolder text-primary mt-lg-4 text-for-help mt-2 text-center" style={{ color: '#2e75b6 !important', fontSize: '35px' }}>
              GIẢI ĐÁP THẮC MẮC VỀ SẢN PHẨM
            </h2>
            <div className="mt-4 text-center">
              <a href="/yeu-cau-ho-tro" className="btn-view-all">
                <b>Xem tất cả </b> <i class="fa fa-forward mx-3"></i>{' '}
              </a>
            </div>

            <div className="d-block d-lg-none">
              <Carousel
                infinite
                autoPlay
                autoPlaySpeed={2000}
                arrows={true}
                responsive={{
                  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
                  tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
                  mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
                }}
              >
                <div className="d-flex justify-content-center align-items-center">
                  <img className="img-support" src={IconSupport2} alt="" />
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <img className="img-support" src={IconSupport3} alt="" />
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <img className="img-support" src={IconSupport4} alt="" />
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <img className="img-support" src={IconSupport1} alt="" />
                </div>
              </Carousel>
            </div>
            <div className="d-none d-lg-block">
              <div className="row" style={{ marginLeft: '-50px' }}>
                <div className="col-lg-3">
                  <div className="item-hotro">
                    <img className="img-support" src={IconSupport2} alt="" />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="item-hotro" style={{ marginTop: '60px' }}>
                    <img className="img-support" src={IconSupport3} alt="" />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="item-hotro">
                    <img className="img-support" src={IconSupport4} alt="" />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="item-hotro" style={{ marginTop: '60px' }}>
                    <img className="img-support" src={IconSupport1} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ backgroundColor: 'rgb(243 243 243 / 42%)' }}>
            <div className="w-60-gigacare container pb-4" style={{ width: '65%' }}>
              <div className="d-flex justify-content-center align-items-center">
                <img className="logo-gigabot-lienhe" style={{ marginTop: '20px' }} src={gigabot21} alt="" />
                <p
                  className="title-lienhe mx-4"
                  style={{
                    fontWeight: '700',
                    fontSize: '35px',
                    color: '#2e75b6',
                  }}
                >
                  LIÊN HỆ VỚI <span style={{ color: '#2db7ee' }}>GIGA</span>CARE
                </p>
              </div>
              <div className="mt-4">
                <div className="row">
                  {/* Hà Nội - Xuân Phương */}
                  <div className="col-lg-4 col-sm-12">
                    <div className="w-100 d-flex flex-column" style={{ height: '100%' }}>
                      <div className="table-lienhe" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1 }}>
                        <div className="text-primary text-city" style={{ fontSize: '24px', fontWeight: '700' }}>
                          <i className="fa fa-map-marker" aria-hidden="true"></i>
                          <span className="mx-3">TP. Hà Nội</span>
                        </div>
                        <p style={{ fontWeight: '700' }} className="my-2">
                          Tòa D, Chung cư Báo Nhân dân, P.Xuân Phương, Hà Nội
                        </p>
                        <div className="mb-2">
                          <p className="fw-bold">Lịch làm việc:</p>
                          <p>Thứ 2 - Thứ 6 từ 08:00 đến 17:00</p>
                          <p>Thứ 7 từ 08:00 đến 15:00</p>
                        </div>
                        <a href="/tram-bao-hanh/ha-noi" className="text-primary text-decoration-underline">
                          Xem bản đồ
                        </a>
                      </div>
                      <hr style={{ opacity: 1, color: '#006cb9', marginTop: '15px' }} />
                    </div>
                  </div>
                  {/* Hà Nội - Sài Đồng */}
                  <div className="col-lg-4 col-sm-12">
                    <div className="w-100 d-flex flex-column" style={{ height: '100%' }}>
                      <div className="table-lienhe" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1 }}>
                        <div className="text-primary text-city" style={{ fontSize: '24px', fontWeight: '700' }}>
                          <i className="fa fa-map-marker" aria-hidden="true"></i>
                          <span className="mx-3">TP. Hà Nội</span>
                        </div>
                        <p style={{ fontWeight: '700' }} className="my-2">
                          186 Sài Đồng, P. Phúc Lợi, Hà Nội
                        </p>
                        <div className="mb-2">
                          <p className="fw-bold">Lịch làm việc:</p>
                          <p>Thứ 2 - Thứ 6 từ 08:00 đến 17:00</p>
                          <p>Thứ 7 từ 08:00 đến 15:00</p>
                        </div>
                        <a href="/tram-bao-hanh/ha-noi-2" className="text-primary text-decoration-underline">
                          Xem bản đồ
                        </a>
                      </div>
                      <hr style={{ opacity: 1, color: '#006cb9', marginTop: '15px' }} />
                    </div>
                  </div>
                  {/* Hồ Chí Minh */}
                  <div className="col-lg-4 col-sm-12">
                    <div className="w-100 d-flex flex-column" style={{ height: '100%' }}>
                      <div className="table-lienhe" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1 }}>
                        <div className="text-primary text-city" style={{ fontSize: '24px', fontWeight: '700' }}>
                          <i className="fa fa-map-marker" aria-hidden="true"></i>
                          <span className="mx-3">TP. Hồ Chí Minh</span>
                        </div>
                        <p style={{ fontWeight: '700' }} className="my-2">
                          55 Minh Phụng, P. Đông Hưng Thuận, TP. Hồ Chí Minh
                        </p>
                        <div className="mb-2">
                          <p className="fw-bold">Lịch làm việc:</p>
                          <p>Thứ 2 - Thứ 6 từ 08:00 đến 17:00</p>
                          <p>Thứ 7 từ 08:00 đến 15:00</p>
                        </div>
                        <a href="/tram-bao-hanh/ho-chi-minh" className="text-primary text-decoration-underline">
                          Xem bản đồ
                        </a>
                      </div>
                      <hr style={{ opacity: 1, color: '#006cb9', marginTop: '15px' }} />
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center mt-4">
                  {/* Đà Nẵng */}
                  <div className="col-lg-4 col-sm-12">
                    <div className="w-100 d-flex flex-column" style={{ height: '100%' }}>
                      <div className="table-lienhe" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1 }}>
                        <div className="text-primary text-city" style={{ fontSize: '24px', fontWeight: '700' }}>
                          <i className="fa fa-map-marker" aria-hidden="true"></i>
                          <span className="mx-3">TP. Đà Nẵng</span>
                        </div>
                        <p style={{ fontWeight: '700' }} className="my-2">
                          35 Chu Mạnh Trinh, P. Cẩm Lệ, Thành phố Đà Nẵng
                        </p>
                        <div className="mb-2">
                          <p className="fw-bold">Lịch làm việc:</p>
                          <p>Thứ 2 - Thứ 6 từ 08:00 đến 17:00</p>
                          <p>Thứ 7 từ 08:00 đến 15:00</p>
                        </div>
                        <a href="/tram-bao-hanh/da-nang" className="text-primary text-decoration-underline">
                          Xem bản đồ
                        </a>
                      </div>
                      <hr style={{ opacity: 1, color: '#006cb9', marginTop: '15px' }} />
                    </div>
                  </div>
                  {/* Hải Phòng */}
                  <div className="col-lg-4 col-sm-12">
                    <div className="w-100 d-flex flex-column" style={{ height: '100%' }}>
                      <div className="table-lienhe" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1 }}>
                        <div className="text-primary text-city" style={{ fontSize: '24px', fontWeight: '700' }}>
                          <i className="fa fa-map-marker" aria-hidden="true"></i>
                          <span className="mx-3">TP. Hải Phòng</span>
                        </div>
                        <p style={{ fontWeight: '700' }} className="my-2">
                          Số 23, BS1 Khu Đô thị PG, P. An Hải, Hải Phòng
                        </p>
                        <div className="mb-2">
                          <p className="fw-bold">Lịch làm việc:</p>
                          <p>Thứ 2 - Thứ 6 từ 08:00 đến 17:00</p>
                          <p>Thứ 7 từ 08:00 đến 15:00</p>
                        </div>
                        <a href="/tram-bao-hanh/hai-phong" className="text-primary text-decoration-underline">
                          Xem bản đồ
                        </a>
                      </div>
                      <hr style={{ opacity: 1, color: '#006cb9', marginTop: '15px' }} />
                    </div>
                  </div>
                  {/* Thanh Hóa */}
                  <div className="col-lg-4 col-sm-12">
                    <div className="w-100 d-flex flex-column" style={{ height: '100%' }}>
                      <div className="table-lienhe" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1 }}>
                        <div className="text-primary text-city" style={{ fontSize: '24px', fontWeight: '700' }}>
                          <i className="fa fa-map-marker" aria-hidden="true"></i>
                          <span className="mx-3">TP. Thanh Hóa</span>
                        </div>
                        <p style={{ fontWeight: '700' }} className="my-2">
                          Km330+445 đường tránh TP, Phường Quảng Phú, Thanh Hóa
                        </p>
                        <div className="mb-2">
                          <p className="fw-bold">Lịch làm việc:</p>
                          <p>Thứ 2 - Thứ 6 từ 08:00 đến 17:00</p>
                          <p>Thứ 7 từ 08:00 đến 15:00</p>
                        </div>
                        <a href="/tram-bao-hanh/thanh-hoa" className="text-primary text-decoration-underline">
                          Xem bản đồ
                        </a>
                      </div>
                      <hr style={{ opacity: 1, color: '#006cb9', marginTop: '15px' }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="w-60-gigacare d-lg-block d-none container pb-4" style={{ width: '65%' }}>
              <div className="title-hotro">
                <div className="d-flex justify-content-center align-items-center">
                  <p className="title-lienhe mx-4" style={{ color: '#2e75b6', fontSize: '35px' }}>
                    <span style={{ color: '#2db7ee' }}>GIGA</span>CARE LUÔN SẴN SÀNG HỖ TRỢ
                  </p>
                  <img className="logo-gigabot-lienhe" style={{ marginTop: '20px' }} src={gigabot12} alt="" />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-sm-12">
                  <img className="logo-gigabot-lienhe w-100" style={{ marginTop: '20px' }} src={Gigacare1} alt="" />
                  <p className="text-helper mt-3 text-center" style={{ color: '#2e75b6' }}>
                    Chăm sóc <span style={{ color: '#2db7ee' }}>khách hàng</span> tận tình
                  </p>
                </div>
                <div className="col-lg-4 col-sm-12">
                  <img className="logo-gigabot-lienhe w-100" style={{ marginTop: '20px' }} src={Gigacare2} alt="" />
                  <p className="text-helper mt-3 text-center" style={{ color: '#2e75b6' }}>
                    Bảo hành <span style={{ color: '#2db7ee' }}>sản phẩm</span> tận tâm
                  </p>
                </div>
                <div className="col-lg-4 col-sm-12">
                  <img className="logo-gigabot-lienhe w-100" style={{ marginTop: '20px' }} src={Gigacare3} alt="" />
                  <p className="text-helper mt-3 text-center" style={{ color: '#2e75b6' }}>
                    Hỗ trợ <span style={{ color: '#2db7ee' }}>kỹ thuật</span> tận nơi
                  </p>
                </div>
              </div>
            </div>
            <div className="d-block d-lg-none px-1 py-4">
              <Carousel
                infinite
                autoPlay
                autoPlaySpeed={2500}
                arrows={false}
                responsive={{
                  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
                  tablet: { breakpoint: { max: 1024, min: 768 }, items: 2 },
                  mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
                }}
              >
                <div className="d-flex flex-column align-items-center w-100 text-center">
                  <img src={Gigacare1} className="w-100" alt="" />
                  <p className="text-helper text-primary mt-3">
                    Chăm sóc <span className="text-info">khách hàng</span> tận tình
                  </p>
                </div>

                <div className="d-flex flex-column align-items-center w-100 text-center">
                  <img src={Gigacare2} className="w-100" alt="" />
                  <p className="text-helper text-primary mt-3">
                    Bảo hành <span className="text-info">sản phẩm</span> tận tâm
                  </p>
                </div>

                <div className="d-flex flex-column align-items-center w-100 text-center">
                  <img src={Gigacare3} className="w-100" alt="" />
                  <p className="text-helper text-primary mt-3">
                    Hỗ trợ <span className="text-info">kỹ thuật</span> tận nơi
                  </p>
                </div>
              </Carousel>
            </div>
          </div>
        </div>

        <div className="cta-wrapper d-none d-lg-block">
          {/* 3 nút CTA */}
          <div className={`cta-group ${open ? 'show' : ''}`}>
            <a href="https://zalo.me/2534077125582624767" target="_blank" rel="noopener noreferrer">
              <button className="cta-btn">
                <div className="cta-btn-inner">
                  <img className="w-100" src={ZaloIcon} alt="" />
                </div>
              </button>
            </a>
            <a href="https://www.facebook.com/gigacarebyhlt" target="_blank" rel="noopener noreferrer">
              <button className="cta-btn">
                <div className="cta-btn-inner" style={{ backgroundColor: '#028fe3' }}>
                  <FontAwesomeIcon fontSize={16} icon={faFacebookF} color="white" />
                </div>
              </button>
            </a>
            <a href="tel:1900633870">
              <button className="cta-btn">
                <div className="cta-btn-inner cta-phonenumber" style={{ backgroundColor: '#028fe3' }}>
                  <FontAwesomeIcon fontSize={16} icon={faPhone} color="white" />
                </div>
              </button>
            </a>
          </div>
          <button className="cta-btn mt-2" onClick={() => setOpen(!open)}>
            <div className="cta-btn-inner" style={{ backgroundColor: '#fff', fontSize: 16 }}>
              {open ? <FontAwesomeIcon icon={faXmark} color="red" /> : <FontAwesomeIcon icon={faCommentDots} color="#028fe3" />}
            </div>
          </button>
        </div>

        <div
          className="d-block d-lg-none d-flex justify-content-evenly align-items-center fixed-bottom bg-white py-1 text-white"
          style={{ boxShadow: '0 -3px 8px rgba(0, 0, 0, 0.3)' }}
        >
          <div>
            <a href="https://www.facebook.com/gigacarebyhlt" className="d-flex align-items-center" target="_blank" rel="noopener noreferrer">
              <div className="cta-btn-inner" style={{ backgroundColor: '#1977f3' }}>
                <FontAwesomeIcon fontSize={20} icon={faFacebookF} color="white" />
              </div>
              <span className="ms-1" style={{ fontFamily: 'Roboto', fontWeight: 500, fontSize: '14px' }}>
                Facebook
              </span>
            </a>
          </div>
          <div className="border" style={{ borderColor: 'black', height: '40px' }}></div>{' '}
          <div>
            <a href="https://zalo.me/2534077125582624767" className="d-flex align-items-center" target="_blank" rel="noopener noreferrer">
              <img
                src={logoZalo}
                style={{
                  width: 35,
                  height: 35,
                  objectFit: 'contain',
                  backgroundColor: 'transparent',
                  mixBlendMode: 'multiply',
                  borderRadius: '40px',
                }}
                alt="Zalo"
              />
              <span className="ms-1" style={{ fontFamily: 'Roboto', fontWeight: 500, fontSize: '14px' }}>
                Zalo Chat
              </span>
            </a>
          </div>
          <div className="border" style={{ borderColor: 'black', height: '40px' }}></div>
          <div>
            <a href="tel:1900633870" className="d-flex align-items-center">
              <div className="cta-btn-inner" style={{ backgroundColor: '#1977f3' }}>
                <FontAwesomeIcon fontSize={16} icon={faPhone} color="white" />
              </div>
              <span className="ms-1" style={{ fontFamily: 'Roboto', fontWeight: 500, fontSize: '14px' }}>
                1900 633 870
              </span>
            </a>
          </div>
        </div>
        {/* <button className='cta-box'>
          <img className='btn-cta w-100'  src={CTAFace} alt='' />
        </button> */}
      </div>
      {/* <div className="py-4 homepage-notice mb-5">
      <h2 className="text-center w-100 fw-bold text-capitalize mt-4 mb-5">
        LIÊN HỆ BỘ PHẬN HỖ TRỢ
      </h2>
      <h4
        className="text-center mx-8 "
        style={{ textTransform: "upperCase" }}
      >
        Vui lòng liên hệ với chúng tôi <br/> nếu thông tin trên không thể 
        giải quyết được vấn đề của bạn
      </h4>
      <div>
        <button className="readmore_button mt-4 mb-4">
              HOTLINE : 1900.633.870
        </button>
      </div>
      <div className='content-text text-center mb-4 mt-3'>
        <p><strong>Đối với Quý khách hàng, chúng tôi luôn mang đến những sản phẩm với chất lượng tốt nhất.</strong></p>
        <p className='mt-2'><strong>Cùng với đó, sự quan tâm hàng đầu của chúng tôi là đặc biệt chú trọng đến dịch vụ chăm sóc, bảo hành trong suốt vòng đời sản phẩm.</strong></p>
      </div>
    </div> */}
    </>
  );
};

export default CheckBaoHanh;
